// extracted by mini-css-extract-plugin
export default {"fade":"Fade_fade__jElHX","inView":"Fade_inView__f97in"};